export const textMultiplier: number = 1;
export const navBackground: string = "rgb(20,20,20)";
export const navTextColor: string = "rgb(240,240,240)";
export const lightModeBackground: string = "rgb(230,230,230)";
export const darkModeBackground: string = "rgb(60,60,60)";
export const lightModeWidgetBackground: string = "rgb(255,255,255)";
export const darkModeWidgetBackground: string = "rgb(25,25,25)";
export const lightModeBorder: string = "rgb(200,200,200)";
export const darkModeBorder: string = "rgb(75,75,75)";
export const lightModeScale: string = "rgb(220,220,220)";
export const darkModeScale: string = "rgb(50,50,50)";
export const lightModeText: string = "rgb(50,50,50)";
export const darkModeText: string = "rgb(200,200,200)";
export const darkModeWidgetBorderColor: string = "rgb(100,100,100)";
export const lightModeWidgetBorderColor: string = "rgb(200,200,200)";
export const accentButtonBackground: string = "rgb(59,113,202)";
export const accentButtonTextWeight: string = "600";
export const accentButtonText: string = "white";
export const priceTagGreen: string = "rgb(26, 152, 26)";
export const positiveGreenVolume: string = "rgb(26, 152, 26,0.3)";
export const positiveGreen: string = "rgb(35, 190, 35)";
export const primaryBlue: string = "rgb(59,113,202)";
export const primaryBlueLight: string = "rgb(59,113,202,0.5)";
export const buttonGrey: string = "rgb(85, 85, 85)";
export const stockYellow: string = "rgb(255, 215, 0)";
export const stockYellowLight: string = "rgb(255, 215, 0,0.75)";
export const stockYellowLight2: string = "rgb(255, 215, 0,0.5)";
export const stockYellow2: string = "rgb(220, 180, 0)";
export const negativeRed: string = "rgb(230, 61, 61)";
export const negativeRedVolume: string = "rgb(230, 61, 61,0.3)";
export const totalPnLBoxWidth: number = 180;
export const stockInfoWidth: number = 220;
export const accountInfoWidth: number = 200;
export const accountBoxWidth: number = 240;
export const tickerBoxWidth: number = 120;
export const currencyBoxWidth: number = 100;
export const cardBoxShadow: string = "0px 5px 10px rgba(0, 0, 0, 0.4)";
